<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsIframe',
  
})
</script>
<template>
  <div
    ref="iframeContainer"
    class="iframe-container"
  >
    <iframe
      id="editor-js-iframe"
      ref="iframe"
      title="iframe"
      scrolling="no"
    />
  </div>
</template>

<script setup lang="ts" name="TlbsIframe">
import { onMounted } from 'vue';
interface Props {
  code: string;
}

const props = withDefaults(defineProps<Props>(), {
  code: '',
});


const iframe = ref<HTMLIFrameElement>();
const iframeContainer = ref<HTMLElement>();

const runCode = (code = '') => {
  if (!iframe.value) {
    return;
  }
  const iFrameWindow = iframe.value.contentWindow;
  let doc;
  if (!iFrameWindow) return;
  if (iFrameWindow.document) {
    doc = iFrameWindow.document;
  }
  if (!doc) {
    return;
  }
  doc.open();
  doc.write(code);
  doc.close();
  // doc 写入新内容可能会导致事件绑定失败，需要重新绑定
  iFrameWindow.removeEventListener('click', clickCallback);
  iFrameWindow.addEventListener('click', clickCallback);
};

const clickCallback = () => {
  if (iframeContainer.value instanceof HTMLElement) {
    iframeContainer.value?.click();
  }
};

watch(props, (newVal) => {
  runCode(newVal.code);
});

onMounted(() => {
  runCode(props.code);
  // 点击iframe触发父节点点击事件
  const iFrame = iframe.value;
  if (!iFrame) return;
  const iFrameWindow = iFrame.contentWindow || iFrame.contentDocument;
  if (!iFrameWindow) return;
  iFrameWindow.addEventListener('click', clickCallback);
});
</script>
